import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5ddbd3dc"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ddbd3dc')) {
      api.createRecord('5ddbd3dc', component.options)
    } else {
      api.reload('5ddbd3dc', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=5ddbd3dc", function () {
      api.rerender('5ddbd3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/ordinary/view.vue"
export default component.exports